module.exports = __webpack_public_path__ + "static/media/Trainicon02@2x.44fb52d3.png";